import { reduxActionTypePrefix } from "../../../constants/module.constants.js";
const prefix = `${reduxActionTypePrefix}/COMMON`;
export {
  prefix
};
//# sourceMappingURL=constants.js.map
